import { render, staticRenderFns } from "./ExtraClassUpdateDialog.vue?vue&type=template&id=7608e497"
import script from "./ExtraClassUpdateDialog.vue?vue&type=script&lang=js"
export * from "./ExtraClassUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports